import { ThreeCircles } from 'react-loader-spinner';

export const ThreeCirclesLoading = props => {

    const { loading, color, customClass, size } = props;

    const width = size ? size : 17;

    const height = size ? size : 17;

        if (loading) {
    
          return (

            <div className={`${customClass}`}>
              <ThreeCircles
       
                  color={color}
                  height={height}
                  width={width}
              />

            </div>
            
            
          );
          
      } 

      return props.children; 
      
    
}



  

  
